import React, { useEffect,useState } from 'react';
import classes from './Admin.module.css'
import { TabView, TabPanel } from 'primereact/tabview';
import { ToastContainer, toast } from 'react-toastify';
import { deleteFootballQuiz, deleteGoalAlertNews, deleteGoalAlertQuiz, fetchContent } from '../Services/api';
import axios from 'axios'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Dropdown } from 'primereact/dropdown';
import UploadFile from '../Components/UploadFile';






const AdminDashboard = () => {

    const [content,setContent] = useState([])
    const [loading,setLoading] = useState(false)

    const [selectedType, setSelectedType] = useState({ name: 'Football Quiz', code: 'FQ' });
    const cities = [
        { name: 'Football Quiz', code: 'FQ' },
        { name: 'Goal Alert Trivia Quiz', code: 'GAQ' },
        { name: 'Goal Alert Trivia News', code: 'GAN' },
       
    ];



    const FetchData=async()=>{
        try{
            setLoading(true)
            const res = await axios.get(fetchContent)
            console.log(res.data)
            setContent(res.data)
            setLoading(false)
        }
        catch(err){
            console.log(err)
            toast.error(err?.response?.data)
        }
    }

   
    const handleDeleteFootballQuiz=async(data)=>{
        try{
            console.log(data)
            const res = await axios.delete(deleteFootballQuiz,{
                params:{
                    id:data.id
                }
            })
            console.log(res)
            FetchData()
            // toast.success(res.data.message)
        }
        catch(err){
            console.log(err)
            toast.error('Error While Deleting')
        }
    }


    const handleDeleteGoalAlertTriviaQuiz=async(data)=>{
        try{
            console.log(data)
            const res = await axios.delete(deleteGoalAlertQuiz,{
                params:{
                    id:data.id
                }
            })
            console.log(res)
            FetchData()
            // toast.success(res.data.message)
        }
        catch(err){
            console.log(err)
            toast.error('Error While Deleting')
        }
    }


    const handleDeleteGoalAlertNews=async(data)=>{
        try{
            console.log(data)
            const res = await axios.delete(deleteGoalAlertNews,{
                params:{
                    id:data.id
                }
            })
            console.log(res)
            FetchData()
            // toast.success(res?.data?.message)
        }
        catch(err){
            console.log(err)
            toast.error('Error While Deleting')
        }
    }


    const handleDownload = (filePath) => {
        const link = document.createElement("a");
        link.href = filePath;
        link.download = filePath.split('/').pop(); // Extracts file name from path
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(()=>{
        FetchData()
    },[])

    



  return (
    <>
    {
        loading ?
        <div className='h-screen w-full flex justify-center items-center bg-black'>
       <p className='text-white text-2xl'> Loading....</p>
        </div>
        :
        <div className={classes.container}>
     <TabView>
                <TabPanel header="Football Quiz Content">
                    <DataTable value={content.footballContent} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="datetime" header="Date"></Column>
                    {/* <Column field="time" header="Time"></Column> */}
                    <Column field="message" header="Message"></Column>
                    <Column field="correct_option" header="Correct Option" className='text-center'></Column>
                    <Column  header="Delete"  className='text-center'
                        body={(rowData) => (
                            // <button onClick={() => handleDelete(rowData)} className="p-button p-button-danger">
                                <i className="pi pi-trash" style={{color:'red',cursor:'pointer'}} onClick={()=>handleDeleteFootballQuiz(rowData)}></i>
                            // </button>
                        )}>
                    </Column>

                </DataTable>
                </TabPanel>
                <TabPanel header="Goal Alert Trivia Quiz">
                <DataTable value={content.goalAlertTriviaContent} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="datetime" header="Date"></Column>
                    {/* <Column field="time" header="Time"></Column> */}
                    <Column field="message" header="Message"></Column>
                    <Column field="correct_option" className='text-center' header="Correct Option"></Column>
                    <Column  header="Delete" className='text-center' style={{textAlign:'center'}}
                        body={(rowData) => (
                            // <button onClick={() => handleDelete(rowData)} className="p-button p-button-danger">
                                <i className="pi pi-trash" style={{color:'red',cursor:'pointer'}} onClick={()=>{handleDeleteGoalAlertTriviaQuiz(rowData)}} ></i>
                            // </button>
                        )}>
                    </Column>

                </DataTable>
                </TabPanel>

                <TabPanel header="Goal Alert News">
                <DataTable value={content.goalContent} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="datetime" header="Date"></Column>
                    <Column field="type" className='text-center' header="Type"></Column>
                    <Column field="message" header="Message"></Column>
                    <Column  header="Delete" className='text-center' style={{textAlign:'center'}}
                        body={(rowData) => (
                            // <button onClick={() => handleDelete(rowData)} className="p-button p-button-danger">
                                <i className="pi pi-trash" style={{color:'red',cursor:'pointer'}} onClick={()=>{handleDeleteGoalAlertNews(rowData)}} ></i>
                            // </button>
                        )}>
                    </Column>

                </DataTable>
                </TabPanel>

                <TabPanel header="Upload Content">

                <p className="text-justify text-xs md:text-lg pb-4 text-red-600 font-semibold" >* Please download the Excel template corresponding to the type of content you wish to upload.</p>
                    
                 <div className='flex justify-end gap-6 '>
                 <Button label="Quiz Sheet Format" icon="pi pi-download"   onClick={() => handleDownload('/files/Quiz_Template.xlsx')}  />
                 <Button label="News Sheet Format" icon="pi pi-download"  onClick={() => handleDownload('/files/News_Template.xlsx')} />
                 </div>
                 <br/>   
                 <div className='flex'>
                 <Dropdown value={selectedType} onChange={(e) => setSelectedType(e.value)} options={cities} optionLabel="name" 
    placeholder="Select Content Type" className='w-[15rem]' />
                 </div>
                 <UploadFile type={selectedType} fetch={FetchData}  />
                </TabPanel>
            </TabView>
    </div>
    }
    
    </>
  );
}

export default AdminDashboard;
